import { render, staticRenderFns } from "./UserInfoPage.vue?vue&type=template&id=22ce3df4&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./UserInfoPage.vue?vue&type=style&index=0&id=22ce3df4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ce3df4",
  null
  
)

export default component.exports